<div class="container-fluid">
    <div class="row">
        <div class="col-lg-7 col-md-7 col-sm-12 col-12">
            <div id="sunBurstChart" class="svgGraph">
            </div>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 col-12">
            <pet-summary-menu-view [summaryMenu]="summaryMenuData"></pet-summary-menu-view>
        </div>
    </div>
</div>
  
  